<template>
  <div class="subsidiary-container">
    <div class="subsidiary-content max-width">
      <div class="subsidiary-title">旗下子公司</div>
      <div class="subsidiary-sub-title">SUBSIDIARY CORPORATION</div>
      <div class="company-list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="logo">
            <img :src="item.icon" alt="" />
          </div>
          <div class="content">
            <div class="title">{{ item.company }}</div>
            <div class="sub-title">{{ item.bewrite }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getSubcompany } from '@/api';
export default {
  data() {
    return {
      list: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const res = await getSubcompany().catch((e) => false);
      if (!res || res.code != 200) return;
      this.list = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('~@/assets/css/common.scss');
.subsidiary-container {
  width: 100%;
  margin-top: 185px;
  .subsidiary-content {
    max-width: 1366px;
    margin: auto;
    .subsidiary-title {
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      color: #333;
      margin-bottom: 13px;
    }
    .subsidiary-sub-title {
      text-align: center;
      font-size: 12px;
      color: #d6d6d6;
      margin-bottom: 103px;
    }
    .company-list {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      .item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        box-shadow: 0px 0px 12px 0px rgba(0, 18, 56, 0.03);
        border-radius: 2px;
        padding: 27px;
        margin-bottom: 12px;
        width: 550px;
        height: 150px;
        .logo {
          margin-right: 10px;
          img {
            width: 70px;
            height: 70px;
          }
        }
        .content {
          letter-spacing: 1px;
          .title {
            font-size: 18px;
            margin-bottom: 10px;
          }
          .sub-title {
            font-size: 14px;
            line-height: 25px;
            color: #333;
          }
        }
      }
    }
  }
}
</style>
